import { render, staticRenderFns } from "./comment-writed.vue?vue&type=template&id=2524f8c6&scoped=true"
import script from "./comment-writed.vue?vue&type=script&lang=js"
export * from "./comment-writed.vue?vue&type=script&lang=js"
import style0 from "./comment-writed.vue?vue&type=style&index=0&id=2524f8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2524f8c6",
  null
  
)

export default component.exports